import { Component, ElementRef, ViewChild } from '@angular/core';
import { SharedStore } from '../../services/shared.store';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  @ViewChild('content') appContent!: ElementRef;

  constructor(private shareStore: SharedStore, private authService: AuthService) {}

  public signOut() {
    this.authService.logout();
  }
}